// Maps a stored icon slug (a Lucide icon name) to a component. Kept out of lib/moments.ts so the
// Worker bundle never pulls in lucide-react.
import {
  Apple,
  Bed,
  Bike,
  BookOpen,
  Brain,
  Briefcase,
  Camera,
  Cloud,
  Coffee,
  Droplet,
  Dumbbell,
  Flame,
  Footprints,
  GlassWater,
  Heart,
  Leaf,
  Moon,
  Music,
  Pencil,
  Pill,
  Smile,
  Sparkles,
  Star,
  Sun,
  Sunrise,
  Target,
  Utensils,
  UtensilsCrossed,
  type LucideIcon
} from "lucide-react";

const ICONS: Record<string, LucideIcon> = {
  Sun,
  Sunrise,
  Moon,
  Coffee,
  Utensils,
  UtensilsCrossed,
  BookOpen,
  Dumbbell,
  Target,
  Camera,
  Heart,
  Sparkles,
  Droplet,
  Pill,
  Brain,
  Music,
  Pencil,
  Briefcase,
  Bed,
  Bike,
  Apple,
  GlassWater,
  Footprints,
  Smile,
  Flame,
  Star,
  Leaf,
  Cloud
};

// Icons offered in the category manage sheet.
export const MOMENT_ICON_CHOICES: string[] = Object.keys(ICONS);

export function resolveMomentIcon(name: string | null | undefined): LucideIcon {
  if (name && ICONS[name]) {
    return ICONS[name];
  }
  return Sparkles;
}

export function MomentIcon({
  name,
  size = 18,
  className
}: {
  name: string | null | undefined;
  size?: number;
  className?: string;
}) {
  const Icon = resolveMomentIcon(name);
  return <Icon size={size} className={className} aria-hidden="true" />;
}
